export default __webpack_public_path__ + "static/media/bulldozer.bf5a14d3.jpg";